// extracted by mini-css-extract-plugin
export default {"section":"SectionCardsGrid__section--slots-I_Yuq","component":"SectionCardsGrid__component--slots-uGlAu","item":"SectionCardsGrid__item--slots-XFssD"};